export const MAX_INVITATION_USES = 999
